<div class="emoji-scale" role="radiogroup" aria-label="Emoji rating scale">
	@for (icon of icons(); track $index) {
		<button
			type="button"
			role="radio"
			class="emoji-scale__btn emoji-scale__btn--{{ icon.sentiment }}"
			[class.emoji-scale__btn--selected]="isSelected($index)"
			[attr.aria-label]="'Rating ' + ($index + 1) + ' of ' + icons().length"
			[attr.aria-checked]="isSelected($index)"
			[disabled]="readonly()"
			(click)="select($index)"
		>
			<md-icon [icon]="icon.icon"></md-icon>
		</button>
	}
</div>
